import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=2760279e&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=2760279e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.3.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2760279e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/erp_Product/erp_front/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2760279e', component.options)
    } else {
      api.reload('2760279e', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=2760279e&scoped=true&", function () {
      api.rerender('2760279e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/Sidebar.vue"
export default component.exports